// styles
import './CardProgram.scss'
// hooks
import useRouterControl from 'hooks/useRouterControl'
// components
import Card from 'components/atoms/card/card'
import Image from 'components/atoms/Image/image'
// props
import PropTypes from 'prop-types'
// helpers
import listRoutes from 'routes/listRoutes'
// assets
import tempImage from 'assets/images/icon-class.png'

export const CardProgram = ({ programId, image, programName, classes, onClick, programUserId }) => {
	// hook
	const { routerControl } = useRouterControl()

	// actions
	const handledActions = id => {
		if (onClick) return onClick(id)
		if (!id) return
		return routerControl({ link: `${listRoutes.programInternal}/${id}/${programUserId}` })
	}

	return (
		<Card classes={classes} onClick={() => handledActions(programId)}>
			<Image src={image || tempImage} width='80' height='80' classes='m-card-program__img' />
			{programName && (
				<>
					<small>Programa</small>
					<h4>{programName}</h4>
				</>
			)}
		</Card>
	)
}

CardProgram.defaultProps = {
	classes: 'm-card-program morphism',
	onClick: false
}

CardProgram.propTypes = {
	classes: PropTypes.oneOf([
		'm-card-program morphism',
		'm-card-program shadow',
		't-program__card morphism'
	]),
	programId: PropTypes.number,
	image: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	programName: PropTypes.string,
	onClick: PropTypes.any
}
